<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="الإهداء">
<h1><span dir="rtl">الإهداء</span></h1>
<p style="text-align: center;"><span dir="rtl">إهداء لروح الوالد وروح الوالدة، تغمَّدَهما اللهُ برحمتِه، وأسكنَهما فَسيحَ جنَّاتِه.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?3cc9c96b